export default __webpack_public_path__ + "static/media/wifi-2.00b4f155.png";